<template>
    <v-card>
        <v-toolbar color="amber darken-2" dark flat dense>
            <v-toolbar-title>Totali</v-toolbar-title>
        </v-toolbar>

        <v-list>
            <v-list-item v-if="permissions.includes('view_projects_tot_hours')">
                <v-list-item-content>
                    <v-list-item-title>
                        <nice-time-editor :value="projectInfo.hours" :disabled="true"></nice-time-editor>
                        ({{ projectInfo.hours }}h)
                    </v-list-item-title>
                    <v-list-item-subtitle>Ore stimate totali</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-divider v-if="permissions.includes('view_projects_tot_hours')"></v-divider>
            <v-list-item v-if="permissions.includes('view_projects_tot_hours_real')">
                <v-list-item-content>
                    <v-list-item-title>
                        <nice-time-editor :value="projectInfo.hours_real" :disabled="true"></nice-time-editor>
                        ({{ projectInfo.hours_real }}h)</v-list-item-title>
                    <v-list-item-subtitle>Ore effettive totali</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-divider v-if="permissions.includes('view_projects_tot_hours_real')"></v-divider>
            <template v-if="projectInfo.hours_real - projectInfo.hours != 0 && permissions.includes('view_projects_tot_diff_hour_real')">
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title>
                            <template v-if="(projectInfo.hours_real - projectInfo.hours) < 0">-</template>
                            <nice-time-editor :value="Math.abs(projectInfo.hours_real - projectInfo.hours)"
                                :disabled="true"></nice-time-editor>
                            ({{ projectInfo.hours_real - projectInfo.hours }}h)</v-list-item-title>
                        <v-list-item-subtitle>Differenza dalle ore stimate</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
            </template>
            <template v-if="showPrices">
                <v-list-item v-if="permissions.includes('view_projects_tot_price')">
                    <v-list-item-content>
                        <v-list-item-title>{{ projectInfo.price | euro }}</v-list-item-title>
                        <v-list-item-subtitle>Totale stimato</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-divider v-if="permissions.includes('view_projects_tot_price')"></v-divider>
                <v-list-item v-if="permissions.includes('view_project_additional_costs')">
                    <v-list-item-content>
                        <v-list-item-title v-if="projectInfo.addictionalCosts != 0" style="color:red">{{ projectInfo.addictionalCosts | euro }}</v-list-item-title>
                        <v-list-item-title v-else>Nessun costo aggiuntivo</v-list-item-title>
                        <v-list-item-subtitle>Costi aggiuntivi</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-divider v-if="permissions.includes('view_project_additional_costs')"></v-divider>
                <v-list-item v-if="permissions.includes('view_projects_tot_real_price')">
                    <v-list-item-content>
                        <v-list-item-title>
                            <price-info :value="projectInfo"></price-info>
                        </v-list-item-title>
                        <v-list-item-subtitle>Totale effettivo</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-divider v-if="permissions.includes('view_projects_tot_real_price')"></v-divider>
                <v-list-item v-if="permissions.includes('view_projects_avg_resource_price')">
                    <v-list-item-content>
                        <v-list-item-title>{{ projectInfo.resourcePrice | euro }}</v-list-item-title>
                        <v-list-item-subtitle>Prezzo medio risorsa (orario)</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-divider v-if="permissions.includes('view_projects_avg_resource_price')"></v-divider>
                <v-list-item v-if="permissions.includes('view_projects_client_price')">
                    <v-list-item-content>
                        <v-list-item-title>{{ value.client_price | euro }}</v-list-item-title>
                        <v-list-item-subtitle>Prezzo al cliente</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-divider v-if="permissions.includes('view_projects_client_price')"></v-divider>
                <v-list-item v-if="permissions.includes('view_projects_revenue')">
                    <v-list-item-content>
                        <price-info :value="{
                            price: projectInfo.revenue,
                            realPrice: projectInfo.revenue,
                            priceDiff: 0 - projectInfo.realPrice
                        }"></price-info>
                        <v-list-item-subtitle>Ricavo</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-divider v-if="permissions.includes('view_projects_revenue')"></v-divider>
            </template>
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title>
                        <sal-progressbar :value="projectInfo.progress"></sal-progressbar>
                    </v-list-item-title>
                    <v-list-item-subtitle>Stato avanzamento progetto</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <template v-if="projectInfo.progress < 100">
                <v-list-item v-if="permissions.includes('view_projects_tot_hours_left')">
                    <v-list-item-content>
                        <v-list-item-title>
                            <nice-time-editor :value="projectInfo.hoursLeft" :disabled="true"></nice-time-editor>
                            ({{ projectInfo.hoursLeft }}h)
                        </v-list-item-title>
                        <v-list-item-subtitle>Ore stimate a fine lavori</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-divider v-if="permissions.includes('view_projects_tot_hours_left')"></v-divider>
            </template>
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title>{{ projectInfo.taskNumber }}</v-list-item-title>
                    <v-list-item-subtitle>Numero task</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title>{{ projectInfo.subTaskNumber }}</v-list-item-title>
                    <v-list-item-subtitle>Numero sotto task</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-card>
</template>
<script>
export default {
    props: {
        value: { required: true, type: Object },
        projectInfo: { required: true, type: Object },
        disabled: { default: false },
        loading: { default: false },
        showPrices: { type: Boolean, default: true },
        permissions: {type: Array, default:[]}
    },
    data() {
        return {
        }
    },
    mounted() {
    },
    computed: {
    },
    methods: {
    },
    components: {},
    filters: {}

}
</script>